const m = require('minthril');
const { component } = require('../../component');

function technologyIcon(name) {
  if (name === 'JavaScript') {
    return m('svg.compatibility-logos__icon', {
      viewBox: '0 0 48 48',
      role: 'img',
      'aria-label': 'JavaScript logo'
    }, [
      m('rect', { width: 48, height: 48, rx: 8, fill: 'currentColor' }),
      m('text', {
        x: 42,
        y: 40,
        fill: '#171522',
        'font-family': 'Arial, sans-serif',
        'font-size': 20,
        'font-weight': 800,
        'text-anchor': 'end'
      }, 'JS')
    ]);
  }

  if (name === 'React') {
    return m('svg.compatibility-logos__icon', {
      viewBox: '0 0 48 48',
      role: 'img',
      'aria-label': 'React logo'
    }, [
      [-30, 30, 90].map(rotation => m('ellipse', {
        cx: 24,
        cy: 24,
        rx: 20,
        ry: 8,
        fill: 'none',
        stroke: 'currentColor',
        'stroke-width': 2.5,
        transform: `rotate(${rotation} 24 24)`
      })),
      m('circle', { cx: 24, cy: 24, r: 3.5, fill: 'currentColor' })
    ]);
  }

  if (name === 'Vue') {
    return m('svg.compatibility-logos__icon', {
      viewBox: '0 0 48 48',
      role: 'img',
      'aria-label': 'Vue logo'
    }, [
      m('path', { d: 'M3 8h9l12 20L36 8h9L24 44 3 8z', fill: 'currentColor' }),
      m('path', { d: 'M15 8h7l2 4 2-4h7L24 23 15 8z', fill: 'var(--surface-panel)' })
    ]);
  }

  if (name === 'Angular') {
    return m('svg.compatibility-logos__icon', {
      viewBox: '0 0 48 48',
      role: 'img',
      'aria-label': 'Angular logo'
    }, [
      m('path', {
        d: 'M24 3 5 10l3 26 16 9 16-9 3-26L24 3zm0 7 12 27h-6l-2-6H20l-2 6h-6L24 10zm0 10-2 6h4l-2-6z',
        fill: 'currentColor'
      })
    ]);
  }

  return m('svg.compatibility-logos__icon', {
    viewBox: '0 0 48 48',
    role: 'img',
    'aria-label': 'Svelte logo'
  }, [
    m('path', {
      d: 'M35.5 8.3c-6.3-5.2-16.4-4.4-23.1 1.8-4.2 3.9-5.9 9.3-4.8 13.9-4.2 5.1-3.7 12.3 1.3 16.5 6.3 5.2 16.4 4.4 23.1-1.8 4.2-3.9 5.9-9.3 4.8-13.9 4.2-5.1 3.7-12.3-1.3-16.5zM15.8 15c3.8-3.5 9.3-4 12.2-1.6 1.2 1 1.3 2.7.3 3.9l-1.4 1.7-4.3-3.6c-.8-.7-2-.6-2.7.2-.7.8-.6 2 .2 2.7l7.2 6c.8.7 2 .6 2.7-.2l2.5-3.1c1.1 2.6.2 6.2-2.5 8.7-3.8 3.5-9.3 4-12.2 1.6-1.2-1-1.3-2.7-.3-3.9l1.4-1.7 4.3 3.6c.8.7 2 .6 2.7-.2.7-.8.6-2-.2-2.7l-7.2-6c-.8-.7-2-.6-2.7.2l-2.5 3.1c-1.1-2.6-.2-6.2 2.5-8.7z',
      fill: 'currentColor'
    })
  ]);
}

const CompatibilityLogos = component(() => ({
  view: ({ attrs }) => {
    const technologies = [
      { name: 'JavaScript', label: 'Vanilla JS', color: '#f7df1e' },
      { name: 'React', label: 'React', color: '#61dafb' },
      { name: 'Vue', label: 'Vue', color: '#42b883' },
      { name: 'Angular', label: 'Angular', color: '#dd0031' },
      { name: 'Svelte', label: 'Svelte', color: '#ff3e00' }
    ];

    return m('section.compatibility-logos', { class: attrs.className || '' }, [
      m('div.compatibility-logos__heading', [
        m('h3', attrs.heading || 'Works with everything'),
        m('p', attrs.description || 'If it runs in a browser, Spache can render it.'),
        m('p.compatibility-logos__future', 'New framework invented tomorrow? Already works in Spache!')
      ]),
      m('ul.compatibility-logos__list', technologies.map(technology => m('li', {
        key: technology.name,
        style: { '--technology-color': technology.color }
      }, [
        technologyIcon(technology.name),
        m('span', technology.label)
      ])))
    ]);
  }
}));

module.exports = { CompatibilityLogos };
